import { RecordTypeEnum } from '@/enums/dialogEnum';
import { chatRequest } from './request';

// 获取工单分类
export function getTicketCategory(type?: number) {
  return chatRequest<API.TicketCategoryItem[]>({
    url: `/api/ticket/ticket/getType`,
    method: 'post',
    data: { type },
  });
}

// 获取工单列表
export function getTicketList(data: API.GetTicketParams) {
  return chatRequest<API.PaginationData<API.TicketItem[]>>({
    url: '/api/ticket/ticket/list',
    method: 'post',
    data,
  });
}

// 获取待处理
export function getOptTicketList() {
  return chatRequest<API.OptTicketItem[]>({
    url: '/api/ticket/ticket/optList',
    method: 'post',
  });
}

// 新建工单
export function saveTicket(
  categoryId: string,
  title: string,
  contact: number,
  contactAccount: string,
  other: any,
) {
  return chatRequest<API.ReturnData<any>>({
    url: '/api/ticket/ticket/add',
    method: 'post',
    data: {
      cat_id: categoryId,
      title,
      contact,
      contact_account: contactAccount,
      ...other,
    },
  });
}

// 获取工单详情
export function getTicketDetail(ticketId: number) {
  return chatRequest<API.OptTicketItem>({
    url: `/api/ticket/ticket/detail/${ticketId}`,
    method: 'post',
  });
}

// 工单评分
export function scoreTicket(ticketId: number, score: number, fix: number, comment: string) {
  return chatRequest<API.ReturnData<any>>(
    {
      // 旧写法缺 /api 前缀，chat.goooy.cn 下恒 404；补全为完整路由
      url: '/api/ticket/ticket/scoreTicket',
      method: 'post',
      data: {
        ticket_id: ticketId,
        score,
        fix,
        comment,
      },
    },
    {
      isGetDataDirectly: false,
    },
  );
}

// 工单置顶/取消置顶
export function topTicket(ticketId: number, isTop: number) {
  return chatRequest<any>({
    url: `/api/ticket/ticket/setTop/${ticketId}/${isTop}`,
    method: 'post',
  });
}

// 关闭工单
export function closeTicket(ticketId: string, closeReason: string) {
  return chatRequest<any>({
    url: 'ticket/closeTicket',
    method: 'post',
    data: {
      ticket_id: ticketId,
      close_reason: closeReason,
    },
  });
}

// 新增回复
export function saveChat(
  ticketId: number,
  type: RecordTypeEnum,
  content: string,
  quoteId?: string,
) {
  return chatRequest<any>({
    url: '/api/ticket/message/send',
    method: 'post',
    data: {
      file_type: type === RecordTypeEnum.TEXT ? undefined : type,
      receiver_id: +ticketId,
      content,
      quote_id: quoteId,
    },
  });
}

// 获取聊天列表
export function getChat(data: API.TicketMsgParams) {
  return chatRequest<API.TicketChartItem[]>({
    url: '/api/ticket/message/list',
    method: 'post',
    data: {
      ...data,
      limit: 20,
    },
  });
}

// 删除聊天记录
export function deleteChat(id: number) {
  return chatRequest<any>({
    url: `/api/ticket/message/revoke/${id}`,
    method: 'delete',
  });
}

// 设置已读
export function readChat(ticketId: number, isRead: number) {
  return chatRequest<API.ReturnData<any>>({
    url: `/api/ticket/ticket/setRead/${ticketId}/${isRead}`,
    method: 'post',
  });
}

// 领取工单
export function getTicket(ticketId: number) {
  return chatRequest<API.ReturnData<string>>({
    url: `/api/ticket/ticket/ownTicket/${ticketId}`,
    method: 'post',
  });
}
